module.exports = __webpack_public_path__ + "media/images/amazon-dc23191420285899af64470382e82d1d.png";